import { v4 as uuidv4 } from "uuid";
import {CreateVisitor} from "../reduxLib/visitorLib";
import store from "../store";
import {createSession} from "../reduxLib/sessionLib";


function visitorIni()
{
    const visitorIniD={
        orders:[],
        uudVisitor:"",
        dateCreated:null,
        visitorAction:"Visit",
        userRelId:null,
    }

    const sessionIniD={
        visitorRelId:null,
        userRelId: null,
        actionIDList:[],
        SessionToken:"",
        SessionCreated:null,
        SessionExpiration:null,
        duration:0,
        isActive:true,
        hasCookie:true,
        isTerminated:false,
        visitorAction: 0,
    }


    let vid = localStorage.getItem("vid");
    let exp = Number(localStorage.getItem("vid_exp"));
    let vidSession = uuidv4();

    if (!vid || !exp || Date.now() > exp) {
        vid = uuidv4();
        sessionIniD.SessionToken = vidSession;
        visitorIniD.uudVisitor = vid;
        visitorIniD.dateCreated = new Date();
        store.dispatch(CreateVisitor(visitorIniD)).unwrap().then(visitor => {
            console.log("Created Visitor:", visitor);
            sessionIniD.visitorRelId = visitor.visitorID;
            sessionIniD.SessionCreated = new Date();
            sessionIniD.SessionExpiration = Date.now() + 24 * 60 * 60 * 1000;
            store.dispatch(createSession(sessionIniD)).unwrap().then(session => {
                console.log("Created Session:", session);
                // Εδώ μπορείς να κάνεις dispatch για να αποθηκεύσεις το session στο store
            }).catch(err => {
                console.error("Error creating session:", err);
            });
        }).catch(err => {
            console.error("Error creating visitor:", err);
        });
        localStorage.setItem("vid", vid);
        localStorage.setItem("vid_exp", Date.now() + 24 * 60 * 60 * 1000);
    }



    return vid;
}
export default visitorIni;

